/* La Veen upgrade pass — global motion pause toggle (WCAG 2.2.2) + header CTA tagger.
   One fixed button pauses/resumes every background video and the hero rotator; choice persists per session. */
(function () {
  if (window.__lvUpgrades) return; window.__lvUpgrades = 1;
  var KEY = 'lv-motion-paused';

  /* ---- tag the 'Coffee Cart' nav links (desktop overflow-list + mobile drawer) so CSS can style them ---- */
  function tagOrderCta() {
    document.querySelectorAll('a.menu-list__link, a.menu-drawer__menu-item, summary.menu-drawer__menu-item').forEach(function (a) { // LV 2.16: in the accordion drawer Coffee Cart is a <summary>
      if ((a.textContent || '').trim() === 'Coffee Cart') { a.classList.add('lv-order-cta'); }
    });
  }

  /* ---- motion pause ---- */
  var btn = document.createElement('button');
  btn.id = 'lv-motion-toggle';
  btn.type = 'button';

  function paused() { return document.documentElement.classList.contains('lv-motion-paused'); }

  function apply(p) {
    document.documentElement.classList.toggle('lv-motion-paused', p);
    document.querySelectorAll('video').forEach(function (v) {
      if (p) { v.pause(); }
      else if (v.autoplay || v.closest('.lvh-band, .lvh-statement__bg, .lvh-split, .lvh-show__media, .lvco__heromedia')) {
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      }
    });
    btn.setAttribute('aria-pressed', p ? 'true' : 'false');
    btn.setAttribute('aria-label', p ? 'Play background motion' : 'Pause background motion');
    btn.textContent = p ? '▶' : '❚❚';
    try { sessionStorage.setItem(KEY, p ? '1' : '0'); } catch (e) {}
  }

  /* safety net: anything that tries to start playing while paused gets re-paused */
  document.addEventListener('play', function (e) {
    if (paused() && e.target && e.target.tagName === 'VIDEO') { e.target.pause(); }
  }, true);

  btn.addEventListener('click', function () { apply(!paused()); });

  /* Mobile polish 2026-08-26 (P1-1): the pill was colliding with the footer email input,
     collection prices and toasts, and appeared on pages with no motion at all. It now
     renders ONLY while a motion element (hero rotator or an ambient video) is actually
     in the viewport — pages without motion never see it. CSS keys off html.lv-motion-onscreen. */
  function watchMotion() {
    var targets = document.querySelectorAll('.lvh-statement, video');
    if (!targets.length || !('IntersectionObserver' in window)) {
      if (targets.length) document.documentElement.classList.add('lv-motion-onscreen');
      return;
    }
    var onScreen = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) onScreen.add(en.target); else onScreen.delete(en.target);
      });
      document.documentElement.classList.toggle('lv-motion-onscreen', onScreen.size > 0);
    }, { threshold: 0.05 });
    targets.forEach(function (t) { io.observe(t); });
  }

  function init() {
    document.body.appendChild(btn);
    var saved = '0';
    try { saved = sessionStorage.getItem(KEY) || '0'; } catch (e) {}
    if (saved === '1') { apply(true); }
    else if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { apply(true); }
    else { apply(false); }
    tagOrderCta();
    watchMotion();
    /* overflow-list settles after load; re-tag a few times, then on resize */
    setTimeout(tagOrderCta, 600);
    setTimeout(tagOrderCta, 2000);
    window.addEventListener('resize', function () { setTimeout(tagOrderCta, 300); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* --- Audit 2026-08-26: GA4 outbound-click tracking for the quote form ----------
   Scope agreed with the Coffee Cart seat: STOREFRONT ONLY. The quote form on
   quote.laveencoffee.com.au stays untagged (first-party); we measure the click
   that leaves for it. The Google & YouTube channel runs GA4 inside Shopify's
   pixel sandbox with no window.gtag, so this loads its own gtag for the same
   property with send_page_view:false — no double page views, events only.
   Event: quote_click { link_text, page_path, section_id }. */
(function () {
  if (window.__lvQuoteTrack) return; window.__lvQuoteTrack = 1;
  var GID = 'G-1TJE25SP2H';
  window.dataLayer = window.dataLayer || [];
  function lvg() { window.dataLayer.push(arguments); }
  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GID;
  document.head.appendChild(s);
  lvg('js', new Date());
  lvg('config', GID, { send_page_view: false });
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href*="quote.laveencoffee.com.au"]') : null;
    if (!a) return;
    var sec = a.closest('[id^="shopify-section"]');
    lvg('event', 'quote_click', {
      link_text: (a.textContent || '').trim().slice(0, 60),
      page_path: location.pathname,
      section_id: sec ? sec.id.split('__').pop() : ''
    });
  }, true);
})();

/* --- Mobile polish 2026-08-26 (P1-3, P1-4, P1-5a, P2-10): phone-only behaviours.
   Everything below either self-gates to <=749px or is display-gated by lv-upgrades.css,
   so desktop behaviour is byte-for-byte unchanged. */
(function () {
  if (window.__lvMobilePolish) return; window.__lvMobilePolish = 1;
  var mobile = window.matchMedia && matchMedia('(max-width: 749px)').matches;

  /* P1-3: the homepage "How the cart works" film was the only mobile video showing raw
     native controls (play bar, scrubber, kebab). On phones it becomes ambient like the
     other five: no controls, muted loop, plays when scrolled into view. Desktop keeps
     the controls film. */
  function ambientCartFilm() {
    if (!mobile) return;
    document.querySelectorAll('[id$="__lv_cartdetail"] video').forEach(function (v) {
      v.removeAttribute('controls');
      v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) {
            if (!v.getAttribute('src') && v.dataset.lvsrc) v.src = v.dataset.lvsrc;
            if (!document.documentElement.classList.contains('lv-motion-paused')) {
              var p = v.play(); if (p && p.catch) p.catch(function () {});
            }
          } else if (v.pause) { v.pause(); }
        });
      }, { rootMargin: '150px' });
      io.observe(v);
    });
  }

  /* P1-4: free-shipping progress in the cart drawer. The announcement bar promises free
     AU shipping over $129 but the drawer never mentioned it. Injected at the top of the
     drawer summary; re-rendered whenever the drawer re-hydrates. Phone-only via CSS. */
  var FS_THRESHOLD = 12900; /* cents, matches the live delivery profile */
  var fsBusy = false;
  function fsUpdate() {
    if (fsBusy) return;
    var summary = document.querySelector('.cart-drawer__summary');
    if (!summary) return;
    fsBusy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var total = c.total_price || 0;
      var node = summary.querySelector('.lv-freeship');
      if (!node) {
        node = document.createElement('div');
        node.className = 'lv-freeship';
        summary.prepend(node);
      }
      if (node.dataset.total === String(total)) return;
      node.dataset.total = String(total);
      var pct = Math.min(100, Math.round(total / FS_THRESHOLD * 100));
      var msg;
      if (total >= FS_THRESHOLD) {
        msg = '<strong>FREE AU shipping unlocked!</strong>';
      } else {
        var away = ((FS_THRESHOLD - total) / 100).toFixed(2);
        msg = 'You’re <strong>$' + away + '</strong> away from FREE AU shipping';
      }
      node.innerHTML = '<p class="lv-freeship__msg">' + msg + '</p>' +
        '<div class="lv-freeship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Progress toward free shipping">' +
        '<span class="lv-freeship__fill" style="width:' + pct + '%"></span></div>';
    }).catch(function () {}).finally(function () { fsBusy = false; });
  }
  function fsWatch() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t); t = setTimeout(fsUpdate, 250);
    }).observe(drawer, { childList: true, subtree: true });
    fsUpdate();
  }

  /* P1-5a: shipping reassurance under the PDP price — the $3.90 price had no context.
     Inserted after the price block (main details only, never the sticky bar). Phone-only via CSS. */
  function shipNote() {
    if (!document.querySelector('product-form-component')) return;
    if (document.querySelector('.lv-ship-note')) return;
    var pr = null;
    document.querySelectorAll('.price').forEach(function (p) {
      if (!pr && !p.closest('sticky-add-to-cart') && !p.closest('product-card') && !p.closest('.quick-add-modal')) pr = p;
    });
    if (!pr) return;
    var host = pr.closest('[class*="block"]') || pr;
    var note = document.createElement('p');
    note.className = 'lv-ship-note';
    note.textContent = 'Ships AU-wide: $9.90 flat, FREE over $129';
    host.insertAdjacentElement('afterend', note);
  }

  /* P2-10: accessibility labels the theme markup is missing. Additive only. */
  function a11y() {
    document.querySelectorAll('a[href*="customer_authentication"]:not([aria-label])').forEach(function (a) {
      a.setAttribute('aria-label', 'Account');
    });
    document.querySelectorAll('header summary:not([aria-label]), .header__drawer summary:not([aria-label])').forEach(function (s) {
      s.setAttribute('role', 'button');
      s.setAttribute('aria-label', 'Menu');
    });
    document.querySelectorAll('quantity-selector-component').forEach(function (q) {
      var btns = q.querySelectorAll('button');
      if (btns.length >= 2) {
        if (!btns[0].getAttribute('aria-label')) btns[0].setAttribute('aria-label', 'Decrease quantity');
        if (!btns[btns.length - 1].getAttribute('aria-label')) btns[btns.length - 1].setAttribute('aria-label', 'Increase quantity');
      }
    });
    /* LV 2.27: the search page had no H1 (Horizon prints its "Search results" title as an h3); expose it as the page heading. */
    var sh = document.querySelector('main[data-template="search"] .search-page__header h3');
    if (sh && !document.querySelector('h1')) { sh.setAttribute('role', 'heading'); sh.setAttribute('aria-level', '1'); }
  }

  function go() { ambientCartFilm(); fsWatch(); shipNote(); a11y(); setTimeout(a11y, 1500); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', go); } else { go(); }
})();

/* --- Quality pass 2026-09-05 (BUG-2): cap every quantity at 100. Shopify has no
   D2C maximum (quantity rules are B2B-catalog only), so the cap lives here: max=100
   on every visible quantity input (PDP, quick add, cart drawer, cart page) and a
   clamp the moment a typed value is committed, before the theme posts it. The
   theme's own +/- buttons use stepUp/stepDown, which honour the max attribute. */
(function () {
  if (window.__lvQtyCap) return; window.__lvQtyCap = 1;
  var MAX = 100;
  var SEL = 'input[name="quantity"], input[name="updates[]"], input[ref="quantityInput"]';
  function clamp(i) {
    if (!i || i.type === 'hidden') return;
    if (i.getAttribute('max') !== String(MAX)) { i.setAttribute('max', MAX); i.setAttribute('data-max', MAX); }
    if (parseInt(i.value, 10) > MAX) { i.value = MAX; }
  }
  function cap() { document.querySelectorAll(SEL).forEach(clamp); }
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (i && i.matches && i.matches(SEL)) clamp(i);
  }, true);
  document.addEventListener('input', function (e) {
    var i = e.target;
    if (i && i.matches && i.matches(SEL) && parseInt(i.value, 10) > MAX) i.value = MAX;
  }, true);
  function go() {
    cap();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(cap, 200); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', go); } else { go(); }
})();

/* --- LV 2.7 (2026-09-22, A1): the pause control lives INSIDE each moving section,
   bottom-right, the way apple.com does it. The floating pill it replaces sat on top
   of buttons on phones. One global state as before: every button drives the hidden
   #lv-motion-toggle, so pause/resume, sessionStorage and reduced-motion all still
   run through the original code above. Videos with their own native controls
   (the desktop feature films) get none. */
(function () {
  if (window.__lvPauseInMedia) return; window.__lvPauseInMedia = 1;
  var PAUSE = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="2.5" y="1.5" width="3" height="11" rx="1" fill="currentColor"/><rect x="8.5" y="1.5" width="3" height="11" rx="1" fill="currentColor"/></svg>';
  var PLAY = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3.5 1.8v10.4a.8.8 0 0 0 1.2.7l8.3-5.2a.8.8 0 0 0 0-1.4L4.7 1.1a.8.8 0 0 0-1.2.7z" fill="currentColor"/></svg>';
  var HOSTS = '.lvh-band, .lvh-statement, .lvh-split__media, .lvh-cx__media, .lvh-show__media, .lvco__heromedia';

  function paused() { return document.documentElement.classList.contains('lv-motion-paused'); }
  function sync(b) {
    var p = paused();
    b.setAttribute('aria-pressed', p ? 'true' : 'false');
    b.setAttribute('aria-label', p ? 'Play background motion' : 'Pause background motion');
    var want = p ? 'play' : 'pause';
    if (b.dataset.state !== want) { b.dataset.state = want; b.innerHTML = p ? PLAY : PAUSE; }
  }
  function place() {
    var seen = [];
    document.querySelectorAll('.lvh-statement, video').forEach(function (el) {
      if (el.tagName === 'VIDEO' && el.hasAttribute('controls')) return;
      var host = el.matches('.lvh-statement') ? el : (el.closest(HOSTS) || el.parentElement);
      if (!host || seen.indexOf(host) > -1) return;
      seen.push(host);
      if (host.querySelector(':scope > .lv-pause')) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lv-pause';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var t = document.getElementById('lv-motion-toggle'); if (t) t.click();
      });
      host.appendChild(b); sync(b);
    });
  }
  function syncAll() { document.querySelectorAll('.lv-pause').forEach(sync); }
  new MutationObserver(syncAll).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  function go() { setTimeout(place, 0); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', go); } else { go(); }
})();

/* ── LV 2.12 · Package B "helpful in the right places" (25 Sep 2026), APPLE-DESIGN-RESEARCH-2026-09-25.md §4 B ──
   1) Open-now badge, built from the hours already printed on the cafés hub cards (.lvcf__hours) and on each
      café page (.lvh-split__hourrow). Perth time via Intl; refreshes every minute; parse failure = no badge.  */
(function () {
  var DAY = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
  var NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  /* LV 2.20: WA public holidays (wa.gov.au, checked 27 Sep 2026, incl. the Monday substitutes). On these days a café
     is closed unless its hours carry a "Public holidays" row (Heritage: 7am to 12pm); every café is closed on
     Christmas Day. Add 2028 when WA publishes it. */
  var PH = {};
  ('2026-01-01 2026-01-26 2026-03-02 2026-04-03 2026-04-05 2026-04-06 2026-04-25 2026-04-27 2026-06-01 2026-09-28 ' +
   '2026-12-25 2026-12-26 2026-12-28 2027-01-01 2027-01-26 2027-03-01 2027-03-26 2027-03-28 2027-03-29 2027-04-25 ' +
   '2027-04-26 2027-06-07 2027-09-27 2027-12-25 2027-12-26 2027-12-27 2027-12-28').split(' ').forEach(function (k) { PH[k] = 1; });
  function days(spec) {
    spec = spec.toLowerCase().replace(/\./g, '');
    if (/public|holiday/.test(spec)) return 'PH';
    if (/weekday/.test(spec)) return [1, 2, 3, 4, 5];
    if (/weekend/.test(spec)) return [0, 6];
    if (/daily|every ?day|7 days|all week/.test(spec)) return [0, 1, 2, 3, 4, 5, 6];
    var range = spec.match(/\b(sun|mon|tue|wed|thu|fri|sat)[a-z]*\s*(?:-|–|—|to)\s*(sun|mon|tue|wed|thu|fri|sat)[a-z]*/);
    if (range) { var out = [], i = DAY[range[1]], end = DAY[range[2]]; for (var n = 0; n < 7; n++) { out.push(i); if (i === end) break; i = (i + 1) % 7; } return out; }
    var m, list = [], re = /\b(sun|mon|tue|wed|thu|fri|sat)[a-z]*/g;
    while ((m = re.exec(spec))) list.push(DAY[m[1]]);
    return list.length ? list : null;
  }
  function mins(h, mm, ap) { h = +h; mm = +(mm || 0); if (ap === 'pm' && h < 12) h += 12; if (ap === 'am' && h === 12) h = 0; return h * 60 + mm; }
  function parseLine(line) {
    var t = String(line || '').replace(/\s+/g, ' ').trim(); if (!t) return null;
    var tm = t.match(/(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)\s*(?:-|–|—|to|until)\s*(\d{1,2})(?:[:.](\d{2}))?\s*(am|pm)/i);
    var d = days(tm ? t.slice(0, tm.index) : t);
    if (!d) return null;
    var ph = d === 'PH'; if (ph) d = [];
    if (!tm) return /\bclosed\b/i.test(t) ? { days: d, ph: ph, closed: true } : null;
    return { days: d, ph: ph, open: mins(tm[1], tm[2], tm[3].toLowerCase()), close: mins(tm[4], tm[5], tm[6].toLowerCase()) };
  }
  function perthNow() {
    var o = {};
    new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Perth', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { day: DAY[String(o.weekday).toLowerCase().slice(0, 3)], min: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10),
      y: +o.year, m: +o.month, d: +o.day };
  }
  function dateKey(now, add) { return new Date(Date.UTC(now.y, now.m - 1, now.d + add)).toISOString().slice(0, 10); }
  function fmt(m) { var h = Math.floor(m / 60), mm = m % 60, ap = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; return h + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + ap; }
  function status(rules) {
    var now = perthNow(); if (now.day === undefined || isNaN(now.min) || !now.y) return null;
    function ruleFor(d, key) {
      var i;
      if (PH[key]) {
        if (/-12-25$/.test(key)) return { closed: true };
        for (i = 0; i < rules.length; i++) if (rules[i].ph) return rules[i];
        return { closed: true };
      }
      for (i = 0; i < rules.length; i++) if (!rules[i].ph && rules[i].days.indexOf(d) > -1) return rules[i];
      return null;
    }
    var today = dateKey(now, 0), r = ruleFor(now.day, today);
    if (r && !r.closed) {
      if (now.min >= r.open && now.min < r.close) return { k: 'on', t: 'Open now · closes ' + fmt(r.close), until: fmt(r.close) };
      if (now.min < r.open) return { k: 'soon', t: 'Opens at ' + fmt(r.open), at: fmt(r.open) };
    }
    var lead = PH[today] && (!r || r.closed) ? 'Public holiday · opens ' : 'Closed now · opens ';
    for (var n = 1; n <= 14; n++) {
      var d = (now.day + n) % 7, q = ruleFor(d, dateKey(now, n));
      if (q && !q.closed) return { k: 'off', t: lead + (n === 1 ? 'tomorrow' : NAMES[d]) + ' ' + fmt(q.open), at: fmt(q.open), day: NAMES[d] };
    }
    return null;
  }
  function badge(rules) {
    var s = status(rules); if (!s) return null;
    var el = document.createElement('span'); el.className = 'lv-open lv-open--' + s.k; el.textContent = s.t; return el;
  }
  function place() {
    document.querySelectorAll('.lvcf__card').forEach(function (card) {
      if (card.querySelector('.lv-open') || card.querySelector('.lvcf__badge')) return;
      var h = card.querySelector('.lvcf__hours'); if (!h) return;
      var rules = h.innerText.split(/\n+/).map(parseLine).filter(Boolean); if (!rules.length) return;
      var b = badge(rules); if (b) h.parentNode.insertBefore(b, h);
    });
    document.querySelectorAll('.lvh-split__hours').forEach(function (box) {
      if (box.querySelector('.lv-open')) return;
      var rules = [].slice.call(box.querySelectorAll('.lvh-split__hourrow')).map(function (row) {
        var d = row.querySelector('.lvh-split__hourday'), t = row.querySelector('.lvh-split__hourtime');
        return d && t ? parseLine(d.textContent + ' ' + t.textContent) : null;
      }).filter(Boolean);
      if (!rules.length) return;
      var b = badge(rules); if (!b) return;
      var label = box.querySelector('.lvh-split__hourslabel');
      if (label) label.insertAdjacentElement('afterend', b); else box.insertBefore(b, box.firstChild);
    });
  }
  function refresh() { document.querySelectorAll('.lv-open').forEach(function (e) { e.remove(); }); place(); }
  window.__lvHours = { parseLine: parseLine, status: status }; // LV 2.14: the mega menu reuses the parser
  function go() { try { place(); } catch (e) {} setInterval(function () { try { refresh(); } catch (e) {} }, 60000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* 2) Nearest café first on the cafés hub. Opt-in by a tap (no location prompt on load). Coordinates come
      from the section's own block settings (data-lat/lng, added in LV 2.12). Cards are re-laid 3 per band
      so the alternating light/dark rows keep their rhythm; tap again to restore the editorial order.        */
(function () {
  var sec = document.querySelector('.lvcf'); if (!sec || !('geolocation' in navigator)) return;
  var head = sec.querySelector('.lvcf__head'); if (!head) return;
  var original = [].slice.call(sec.querySelectorAll('.lvcf__card'));
  if (original.filter(function (c) { return c.dataset.lat && c.dataset.lng; }).length < 2) return;
  var containers = [].slice.call(sec.querySelectorAll('.lvcf__band')).map(function (b) { var c = b.querySelector('.lvcf__card'); return c ? c.parentElement : null; }).filter(Boolean);
  if (!containers.length) return;
  var LABEL = 'Sort by distance';
  var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'lv-near'; btn.setAttribute('aria-pressed', 'false'); btn.textContent = LABEL;
  head.appendChild(btn);
  function km(a, b, c, d) { var R = 6371, dLat = (c - a) * Math.PI / 180, dLng = (d - b) * Math.PI / 180, x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2); return 2 * R * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x)); }
  function lay(list) { var i = 0; containers.forEach(function (ct) { for (var n = 0; n < 3 && i < list.length; n++, i++) ct.appendChild(list[i]); }); }
  function restore() { lay(original); sec.querySelectorAll('.lv-dist').forEach(function (e) { e.remove(); }); btn.textContent = LABEL; btn.setAttribute('aria-pressed', 'false'); btn.classList.remove('is-on'); }
  function sortBy(lat, lng) {
    var ranked = [].slice.call(sec.querySelectorAll('.lvcf__card')).map(function (c) {
      var ok = c.dataset.lat && c.dataset.lng && !c.querySelector('.lvcf__badge');
      return { c: c, d: ok ? km(lat, lng, +c.dataset.lat, +c.dataset.lng) : Infinity };
    }).sort(function (a, b) { return a.d - b.d; });
    ranked.forEach(function (r) {
      var old = r.c.querySelector('.lv-dist'); if (old) old.remove();
      if (!isFinite(r.d)) return;
      var s = document.createElement('span'); s.className = 'lv-dist';
      s.textContent = r.d < 1 ? Math.max(10, Math.round(r.d * 100) * 10) + ' m away' : (Math.round(r.d * 10) / 10) + ' km away';
      var name = r.c.querySelector('.lvcf__name'); if (name) name.insertAdjacentElement('afterend', s);
    });
    lay(ranked.map(function (r) { return r.c; }));
    btn.textContent = 'Nearest first'; btn.setAttribute('aria-pressed', 'true'); btn.classList.add('is-on');
  }
  btn.addEventListener('click', function () {
    if (btn.getAttribute('aria-pressed') === 'true') { restore(); return; }
    btn.textContent = 'Finding you…'; btn.disabled = true;
    navigator.geolocation.getCurrentPosition(
      function (pos) { btn.disabled = false; sortBy(pos.coords.latitude, pos.coords.longitude); },
      function () { btn.disabled = false; btn.textContent = 'Location not shared'; setTimeout(function () { if (btn.getAttribute('aria-pressed') !== 'true') btn.textContent = LABEL; }, 2500); },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
  });
})();

/* ── LV 2.11 · Package C "structure" (26 Sep 2026), APPLE-DESIGN-RESEARCH-2026-09-25.md §4 C.
   Dots + paddles on any card row that actually overflows: the packages, reviews and reels rows
   (phone swipe rows since A3; desktop only if a grid ever scrolls). Apple's gallery pattern:
   8px dot tabs and 36px round paddles, paddles hidden on touch. Rows that fit get nothing.     */
(function () {
  var ROWS = '.lvpr__grid, .lvrv__grid, .lvh-reels__grid';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cardsOf(row) { return [].slice.call(row.children).filter(function (c) { return c.offsetWidth > 40 && !c.classList.contains('lv-dots'); }); }
  function activeIndex(row, cards) {
    var mid = row.getBoundingClientRect().left + row.clientWidth / 2, best = 0, dist = Infinity;
    cards.forEach(function (c, i) { var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid); if (d < dist) { dist = d; best = i; } });
    return best;
  }
  function goTo(card) { card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }); }
  function setup(row) {
    var ox = getComputedStyle(row).overflowX, scroller = ox === 'auto' || ox === 'scroll';
    var cards = cardsOf(row), overflow = scroller && row.scrollWidth > row.clientWidth + 8, box = row.__lvbox;
    if (!overflow || cards.length < 2) { if (box) box.style.display = 'none'; return; }
    if (!box) {
      box = document.createElement('div'); box.className = 'lv-dots';
      var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'lv-paddle lv-paddle--prev'; prev.setAttribute('aria-label', 'Previous');
      var next = document.createElement('button'); next.type = 'button'; next.className = 'lv-paddle lv-paddle--next'; next.setAttribute('aria-label', 'Next');
      var list = document.createElement('div'); list.className = 'lv-dots__list'; list.setAttribute('role', 'tablist');
      box.appendChild(prev); box.appendChild(list); box.appendChild(next);
      row.insertAdjacentElement('afterend', box); row.__lvbox = box;
      prev.addEventListener('click', function () { var c = cardsOf(row); goTo(c[Math.max(0, activeIndex(row, c) - 1)]); });
      next.addEventListener('click', function () { var c = cardsOf(row); goTo(c[Math.min(c.length - 1, activeIndex(row, c) + 1)]); });
      var pending = false;
      row.addEventListener('scroll', function () { if (pending) return; pending = true; setTimeout(function () { pending = false; sync(row); }, 80); }, { passive: true });
    }
    box.style.display = '';
    var list = box.querySelector('.lv-dots__list');
    if (list.children.length !== cards.length) {
      list.innerHTML = '';
      cards.forEach(function (c, i) {
        var d = document.createElement('button'); d.type = 'button'; d.className = 'lv-dots__dot'; d.setAttribute('role', 'tab'); d.setAttribute('aria-label', 'Item ' + (i + 1) + ' of ' + cards.length);
        d.addEventListener('click', function () { goTo(c); }); list.appendChild(d);
      });
    }
    sync(row);
  }
  function sync(row) {
    var box = row.__lvbox; if (!box || box.style.display === 'none') return;
    var cards = cardsOf(row), i = activeIndex(row, cards), dots = box.querySelectorAll('.lv-dots__dot');
    [].forEach.call(dots, function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
    box.querySelector('.lv-paddle--prev').disabled = i === 0;
    box.querySelector('.lv-paddle--next').disabled = i >= cards.length - 1;
  }
  function all() { document.querySelectorAll(ROWS).forEach(function (row) { try { setup(row); } catch (e) {} }); }
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(all, 150); });
  function go() { all(); setTimeout(all, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* Progressive disclosure on phones (Apple HIG Layout, 9 Sep 2026: "use progressive disclosure to make layouts
   cleaner"). Coffee Cart at 375px: rates 1,038px, add-ons 908px, compare 845px. Each rates column keeps its first
   3 rows, the comparison table its first 4, each add-on group its first 3 chips; the rest sits behind one 44px
   "show more" pill. Desktop untouched; unfolds itself if the viewport grows past 749px.                          */
(function () {
  var mq = window.matchMedia ? matchMedia('(max-width: 749px)') : null; if (!mq) return;
  var folds = [];
  function fold(items, keep, after, label, more) {
    if (items.length <= keep + 1) return;
    var hidden = items.slice(keep), btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'lv-more'; btn.setAttribute('aria-expanded', 'false');
    var closed = label.replace('%n', hidden.length), opened = more || 'Show less';
    btn.textContent = closed;
    after.insertAdjacentElement('afterend', btn);
    var f = { items: hidden, btn: btn, open: false, closed: closed, opened: opened };
    btn.addEventListener('click', function () { f.open = !f.open; apply(f); if (!f.open) after.scrollIntoView({ block: 'nearest' }); });
    folds.push(f); apply(f);
  }
  function apply(f) {
    var on = mq.matches && !f.open;
    f.items.forEach(function (el) { el.classList.toggle('lv-fold-hidden', on); });
    f.btn.style.display = mq.matches ? '' : 'none';
    f.btn.textContent = f.open ? f.opened : f.closed;
    f.btn.setAttribute('aria-expanded', f.open ? 'true' : 'false');
    f.btn.classList.toggle('is-open', f.open);
  }
  function go() {
    document.querySelectorAll('.lvrt__col').forEach(function (col) {
      var rows = [].slice.call(col.querySelectorAll('.lvrt__row')); fold(rows, 3, rows[rows.length - 1], 'Show %n more rates');
    });
    document.querySelectorAll('.lvcp__table').forEach(function (t) {
      var rows = [].slice.call(t.querySelectorAll('.lvcp__row')); fold(rows, 4, t, 'Full comparison (%n more)', 'Show less');
    });
    document.querySelectorAll('.lvgd__group').forEach(function (g) {
      var chips = [].slice.call(g.querySelectorAll('.lvgd__chip')), box = g.querySelector('.lvgd__chips'); if (box) fold(chips, 3, box, '+ %n more');
    });
    var onChange = function () { folds.forEach(apply); };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* LV 2.12 (E4): Instagram's embed.js swaps our <blockquote>s for untitled iframes (Lighthouse frame-title).
   Title them as they appear; covers any other untitled embed too. */
(function () {
  function title() {
    document.querySelectorAll('iframe:not([title])').forEach(function (f) {
      var s = f.getAttribute('src') || '';
      if (/instagram\.com/.test(s)) f.setAttribute('title', 'Instagram reel');
      else if (/youtube\.com|youtu\.be/.test(s)) f.setAttribute('title', 'Video');
      else if (/google\.com\/maps|openstreetmap/.test(s)) f.setAttribute('title', 'Map');
    });
  }
  function go() { title(); try { new MutationObserver(title).observe(document.body, { childList: true, subtree: true }); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* ── LV 2.14 · Mega-menu dress-up (26 Sep 2026), APPLE-DESIGN-RESEARCH-2026-09-25.md §7 ──
   Horizon only draws images for collection links, so every other dropdown of "Horizon Main v2" was a bare
   text column. For the desktop submenus this adds a kicker row (gold label + one "all" link or a note), an
   image tile for EVERY link (cafés from the hub's cover photos, with an open-now dot from their hours), and
   Playfair titles with a one-line sub. The data sits here on purpose: a Horizon update can't drop it and the
   menu stays plain links. Keep CAFES in step with templates/page.sections-6.json. Images load on first hover. */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0025/0285/2643/';
  var CAFES = { // page → [cover, short street, hours (| = new line)]
    '/pages/ks': ['files/w-img057.jpg?v=1782885515', 'King St', 'Weekdays 6am - 2pm|Weekends 7am - 12pm|Public holidays 7am - 12pm'],
    '/pages/rq': ['files/w-img060.jpg?v=1782885653', 'Raine Square', 'Weekdays 6:30am - 2pm'],
    '/pages/bm': ['files/w-img061.jpg?v=1782885516', 'BankWest Tower', 'Mon-Thu 7am - 12:30pm|Fri 7am - 11:30am'],
    '/pages/ms': ['files/w-img058.jpg?v=1782885516', 'Mill St', 'Weekdays 6:30am - 2pm'],
    '/pages/pt': ['files/w-img059.jpg?v=1782885516', 'Palace Tower', 'Mon-Thu 6:30am - 3pm|Fri 6:30am - 2pm'],
    '/pages/el': ['files/w-img055.jpg?v=1782885652', 'The Esplanade', 'Weekdays 6:30am - 1pm'],
    '/pages/ch': ['files/w-img056.jpg?v=1782885516', 'Esplanade, L2', 'Mon-Thu 6:30am - 2:30pm'],
    '/pages/et': ['files/w-img062.jpg?v=1782885516', 'Exchange Tower', 'Mon-Thu 6:15am - 2:30pm|Fri 6:15am - 2pm'],
    '/pages/mh': ['files/w-img054.jpg?v=1782885516', 'Murray House', 'Mon-Thu 6:30am - 3pm|Fri 6:30am - 2pm']
  };
  var TILES = { // link → [image (null = Horizon already drew one), sub]
    '/collections/all': [null, 'Beans, drip bags and gifts'],
    '/collections/coffeebeans': [null, 'Blends and single origins'],
    '/collections/drip-bags': [null, 'Single-serve pour-over'],
    '/collections/gift': [null, 'For the coffee lover'],
    '/pages/maison': ['files/lvb-breakfast-1.jpg?v=1781170884', 'Coming early November'], // LV 2.26: a tile until it opens; on opening day move it to CAFES with its hours (open-now dot). LV 2.27: date not fixed yet
    '/pages/dripbag': ['files/w-film-exotic-p.jpg?v=1782959609', 'Tear, rest, pour, sip'], // LV 2.17: hands-on-cup still, not the white how-to poster
    '/products/heritage-drip-bag-winter-blend': ['files/w-img039.jpg?v=1782885516', 'Six coffees in one box'], // LV 2.17: the box shot; the fanned cards were already the collection tile
    '/products/gift-box-30-pack': ['files/MultiPacks-p.jpg?v=1784254726', 'Your design, your box'],
    '/pages/custom-drip-bag': ['files/Mug-Drip-Bag-Beach.jpg?v=1613518697', 'Your logo, from 30 bags'], // LV 2.26: drip bags for business
    '/pages/classes': ['files/w-img035.jpg?v=1782885515', 'Espresso, brewing, origins'],
    '/pages/classes#lv-classes-1': ['files/w-class-espresso2.jpg?v=1783001152', 'Espresso + latte art'], // LV 2.18: the three classes, one tile each
    '/pages/classes#lv-classes-2': ['files/w-img044.jpg?v=1782885516', 'Filter + pour over'],
    '/pages/classes#lv-classes-3': ['files/w-img028.jpg?v=1782885515', 'Origins + culture'],
    '/pages/classes#lv-gift': ['files/w-class-explore.jpg?v=1782896458', 'Treat a coffee lover'],
    // LV 2.16 · Coffee Cart + Catering panels: anchors into the pages' own sections (ids from their templates), images from those sections
    '/pages/events#lv-packages': ['files/w-espresso-pull.jpg?v=1783139140', 'Packages from $895, ex GST'], // LV 2.18: the "Rates" tile opens the package prices
    '/pages/events#lv-included': ['files/w-carthero3-p.jpg?v=1783143741', 'The whole experience'],
    '/pages/events#lv-rates': ['files/w-espresso-pull.jpg?v=1783139140', 'The full pricing picture'],
    '/pages/events#lv-recurring': ['files/w-cart-balloons.jpg?v=1783139140', 'Short term or long term'],
    '/pages/events#lv-gallery': ['files/w-film-decjuba-p.jpg?v=1782996033', 'Carts in the wild'],
    '/pages/catering#lv-signature': ['files/w-famousbun2.jpg?v=1782997497', 'Our signature'],
    '/pages/catering#lv-menus': ['files/w-catering-food.jpg?v=1782892878', 'Pickup or delivery'], // LV 2.27: was "Drop-off catering"
    '/pages/catering#lv-dietary': ['files/w-cater-fullservice.jpg?v=1783145304', 'Something for every guest'],
    '/pages/catering#lv-gallery': ['files/w-cater-pool-12.jpg?v=1783143741', 'A taste of the table']
  };
  var PANELS = { // top-level link → kicker + one "all" link, or a note
    '/pages/la-veen-cafes': { kicker: 'Nine cafés across the Perth CBD', all: ['All cafés & map', '/pages/la-veen-cafes'] },
    '/collections': { kicker: 'Coffee, delivered', note: 'Free AU shipping over $129' },
    '/pages/dripbag': { kicker: 'Café coffee, no machine', note: 'Brews in about three minutes' },
    '/pages/classes': { kicker: 'Learn at La Veen', all: ['Enquire about a class', '/pages/contact'] },
    '/pages/events': { kicker: 'Real coffee, at your event', all: ['Get a quote', '/pages/events#lv-cta'] },
    '/pages/catering': { kicker: 'Boutique catering, coffee built in', all: ['Get a catering quote', '/pages/catering#lv-cta'] }
  };
  function el(tag, cls, text) { var e = document.createElement(tag); e.className = cls; if (text) e.textContent = text; return e; }
  function meta(href) { return TILES[href] || TILES[href.split('#')[0] + '#'] || null; }
  function dotFor(sub, cafe) {
    var H = window.__lvHours; if (!H) return;
    var st = H.status(cafe[2].split('|').map(H.parseLine).filter(Boolean));
    var dot = sub.querySelector('.lv-mm__dot') || sub.insertBefore(el('span', 'lv-mm__dot'), sub.firstChild);
    var word = sub.querySelector('.lv-mm__state') || sub.insertBefore(el('span', 'lv-mm__state'), dot.nextSibling);
    dot.className = 'lv-mm__dot' + (st ? ' lv-mm__dot--' + st.k : '');
    word.textContent = st ? (st.k === 'on' ? 'Open now' : 'Opens ' + (st.k === 'off' ? st.day + ' ' : '') + st.at) + ' \u00b7' : ''; // LV 2.15: say when it opens, not just "Closed"
    // the break opportunity must sit OUTSIDE the nowrap span, or the street can't wrap under it in the drawer
    if (!(word.nextSibling && word.nextSibling.nodeType === 3 && word.nextSibling.nodeValue === ' ')) sub.insertBefore(document.createTextNode(' '), word.nextSibling);
    if (st) sub.setAttribute('title', st.t); else sub.removeAttribute('title');
  }
  function tile(a, o) {
    o = o || {}; var imgClass = o.imgClass || 'mega-menu__link-image';
    var href = a.getAttribute('href') || '', t = a.querySelector('.wrap-text'); if (!t || a.querySelector('.lv-mm__body')) return;
    var cafe = CAFES[href], m = meta(href), src = cafe ? cafe[0] : (m && m[0]), w = o.w || (cafe ? 480 : 640);
    var img = a.querySelector('.' + imgClass);
    if (!img && src) {
      img = el('img', imgClass); img.alt = ''; img.decoding = 'async'; img.width = w; img.height = Math.round(w * (cafe ? 2 / 3 : 9 / 16));
      img.setAttribute('data-lvsrc', CDN + src + '&width=' + w); a.insertBefore(img, t);
    }
    if (img) { var wrap = el('span', 'lv-mm__media'); a.insertBefore(wrap, img); wrap.appendChild(img); img.addEventListener('load', function () { wrap.classList.add('is-loaded'); }); if (img.complete && img.naturalWidth) wrap.classList.add('is-loaded'); }
    var body = el('span', 'lv-mm__body'); a.insertBefore(body, t); body.appendChild(t); t.classList.add('lv-mm__title');
    var subText = cafe ? cafe[1] : (m && m[1]);
    if (subText) { var sub = el('span', 'lv-mm__sub'); sub.appendChild(document.createTextNode(subText)); body.appendChild(sub); if (cafe) { sub.setAttribute('data-cafe', href); dotFor(sub, cafe); } }
  }
  function load(li) { li.querySelectorAll('img[data-lvsrc]').forEach(function (i) { i.src = i.getAttribute('data-lvsrc'); i.removeAttribute('data-lvsrc'); }); }
  function dress(ul) {
    if (ul.classList.contains('lv-mm')) return;
    var li = ul.closest('.menu-list__list-item'), top = li && li.querySelector('.menu-list__link');
    var key = top ? (top.getAttribute('href') || '').replace(/\/$/, '') : '', panel = PANELS[key];
    // Text-mode menus stack every link inside ONE column; give each link its own column so it can be a tile.
    var cols = [];
    [].slice.call(ul.children).forEach(function (c) {
      if (!c.classList.contains('mega-menu__column')) return;
      var divs = [].slice.call(c.children).filter(function (d) { return d.tagName === 'DIV'; });
      if (divs.length <= 1) { cols.push(c); return; }
      divs.forEach(function (d) { var one = el('li', 'mega-menu__column'); one.appendChild(d); ul.insertBefore(one, c); cols.push(one); });
      c.remove();
    });
    if (panel) {
      var k = el('li', 'lv-mm__kicker'); k.appendChild(el('span', 'lv-mm__kicker-label', panel.kicker));
      if (panel.all) {
        var a = el('a', 'lv-mm__kicker-link', panel.all[0]); a.href = panel.all[1]; k.appendChild(a);
        cols = cols.filter(function (c) { var l = c.querySelector('.mega-menu__link'); if (l && l.getAttribute('href') === panel.all[1]) { c.remove(); return false; } return true; });
      } else if (panel.note) k.appendChild(el('span', 'lv-mm__kicker-note', panel.note));
      ul.insertBefore(k, ul.firstChild);
    }
    cols.forEach(function (c) { var a = c.querySelector('.mega-menu__link'); if (a) tile(a); });
    ul.classList.add('lv-mm', 'lv-mm--n' + cols.length); if (key === '/pages/la-veen-cafes') ul.classList.add('lv-mm--cafes');
    if (li) { var prime = function () { load(li); li.querySelectorAll('.lv-mm__sub[data-cafe]').forEach(function (s) { dotFor(s, CAFES[s.getAttribute('data-cafe')]); }); };
      li.addEventListener('pointerenter', prime); li.addEventListener('focusin', prime); }
  }
  /* LV 2.15 · Phone drawer: the header block now runs Horizon's accordion drawer (drawer_accordion = true), so each
     group is <details><summary>Cafés</summary><ul class="menu-drawer__menu--childlist details-content">. Same tiles as the
     desktop dropdown, two per row, kicker on top; images load the first time a group is opened. Flat-mode child lists
     (no <details>) are left alone: the 2026-08-27 CSS still hides those. */
  var HANDLES = { cafes: '/pages/la-veen-cafes', shop: '/collections', 'drip-bag': '/pages/dripbag', classes: '/pages/classes', 'coffee-cart': '/pages/events', catering: '/pages/catering' };
  function dressDrawer(ul) {
    if (ul.classList.contains('lv-dm')) return;
    var details = ul.closest('details'); if (!details) return;
    var key = HANDLES[(details.id || '').replace('Details-menu-drawer-', '')] || '', panel = PANELS[key];
    var items = [].slice.call(ul.children).filter(function (li) { return li.querySelector('.menu-drawer__menu-item--child'); });
    if (panel) {
      var k = el('li', 'lv-mm__kicker'); k.appendChild(el('span', 'lv-mm__kicker-label', panel.kicker));
      if (panel.all) {
        var a = el('a', 'lv-mm__kicker-link', panel.all[0]); a.href = panel.all[1]; k.appendChild(a);
        items = items.filter(function (li) { var l = li.querySelector('.menu-drawer__menu-item--child'); if (l && l.getAttribute('href') === panel.all[1]) { li.remove(); return false; } return true; });
      } else if (panel.note) k.appendChild(el('span', 'lv-mm__kicker-note', panel.note));
      ul.insertBefore(k, ul.firstChild);
    }
    items.forEach(function (li) { tile(li.querySelector('.menu-drawer__menu-item--child'), { imgClass: 'menu-drawer__link-image', w: 360 }); });
    ul.classList.add('lv-mm', 'lv-dm'); if (key === '/pages/la-veen-cafes') ul.classList.add('lv-mm--cafes');
    var prime = function () { if (!details.open) return; load(details); details.querySelectorAll('.lv-mm__sub[data-cafe]').forEach(function (s) { dotFor(s, CAFES[s.getAttribute('data-cafe')]); }); };
    details.addEventListener('toggle', prime); prime();
  }
  function all() {
    document.querySelectorAll('#header-component .menu-list__submenu .mega-menu__list').forEach(function (ul) { try { dress(ul); } catch (e) {} });
    document.querySelectorAll('#header-component header-drawer .menu-drawer__menu--childlist').forEach(function (ul) { try { dressDrawer(ul); } catch (e) {} });
  }
  // Horizon re-renders the header once after load (Section Rendering API), which throws the first pass away.
  function go() { all(); try { var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(all, 60); }).observe(document.getElementById('header-component') || document.body, { childList: true, subtree: true }); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* ── LV 2.16 · Stable section anchors. Shopify section ids look like shopify-section-template--<id>__<key>, and the
   <id> changes with every theme duplicate, so a menu link to one would break at the next publish. Menu links use
   #lv-<key> instead; this finds the section whose id ends in __<key> and scrolls to it under the sticky header
   (and the pill sub-nav when the page has one). Runs on load, after load, and on same-page hash changes. */
(function () {
  function section(key) { return document.querySelector('[id^="shopify-section-template--"][id$="__' + key + '"]'); }
  function target() {
    var m = /^#lv-([a-z0-9_-]+)$/i.exec(location.hash || ''); if (!m) return null;
    var el = section(m[1]); if (el) return el;
    // LV 2.18: #lv-<key>-<n> = the nth row inside that section (the three classes on /pages/classes)
    var n = /^(.+)-(\d+)$/.exec(m[1]), host = n && section(n[1]);
    return host ? host.querySelectorAll('.lvh-cx__row')[+n[2] - 1] || host : null;
  }
  function offset() {
    var h = document.getElementById('header-component'), n = document.querySelector('.lvsn'), o = 12;
    if (h) o += h.getBoundingClientRect().height;
    if (n) o += n.getBoundingClientRect().height; // the pill bar pins itself once it passes the header, which it will have after the jump
    return o;
  }
  function go() { var el = target(); if (!el) return; el.style.scrollMarginTop = offset() + 'px'; el.scrollIntoView({ block: 'start', behavior: 'instant' }); } // instant: a CSS smooth scroll can be cut short by late layout
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  window.addEventListener('load', function () { setTimeout(go, 150); });
  window.addEventListener('hashchange', go);
})();
